import { apiSelectors, apiActions } from '~/api';

export const cancelAbortableRequests = (store) => (next) => (action) => {
  next(action);

  if (action.type === '@@router/LOCATION_CHANGE') {
    const abortableRequests = apiSelectors.selectAbortableRequests(store.getState());

    abortableRequests.forEach((abortableRequest) => {
      abortableRequest.controller.abort();

      next(apiActions.removeAbortableRequest(abortableRequest.url));
    });
  }
};
